export enum OnboardingStep {
    Introduction = 1,
    ContactMeHelp = 2,
    ContactForm = 3,
    OnBoardingCompleted = 4,
}
